import { render, staticRenderFns } from "./ConversionsForecast.vue?vue&type=template&id=310665ad&"
import script from "./ConversionsForecast.vue?vue&type=script&lang=ts&"
export * from "./ConversionsForecast.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports